import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import { 
  FaShoppingBag, 
  FaMobileAlt, 
  FaLaptopCode, 
  FaRobot, 
  FaArrowRight 
} from "react-icons/fa";
import { Navigation, Thumbs } from 'swiper/modules';
import { Link } from 'react-router-dom';

const Hero = () => {
  const mainSwiperRef = useRef(null);
  const [activeThumb, setActiveThumb] = useState(0);

  const handleThumbClick = (index) => {
    if (mainSwiperRef.current && mainSwiperRef.current.swiper) {
      mainSwiperRef.current.swiper.slideTo(index);
      setActiveThumb(index);
    }
  };

  const slides = [
    {
      id: 1,
      caption: "Shopify 2.0 & Headless E-Commerce",
      heading: 'High-Converting Shopify Stores Engineered to Scale',
      cap1: "Bespoke ",
      cap2: "Shopify ",
      cap3: "Stores",
      text: 'Custom Liquid themes, Recharge subscriptions, 1-click cart drawers, and sub-second Hydrogen headless builds designed for maximum average order value and global sales.',
      buttonLabel: 'Explore Shopify Stores',
      imageSrc: '/images/b1.svg',
      altText: 'Custom Shopify E-Commerce Development',
    },
    {
      id: 2,
      caption: "Cross-Platform Mobile Apps",
      heading: 'Native iOS & Android Mobile Apps with Flutter',
      cap1: "Flutter ",
      cap2: "& ",
      cap3: "React Native",
      text: 'Production-ready cross-platform mobile apps featuring 60fps silky UI, biometric wallets, live GPS tracking, offline databases, and seamless in-app subscriptions.',
      buttonLabel: 'Explore Mobile Apps',
      imageSrc: '/images/b2.svg',
      altText: 'Cross-Platform Mobile App Development',
    },
    {
      id: 3,
      caption: "Custom SaaS & MVP Engineering",
      heading: 'Rapid Zero-to-One SaaS Platforms & Web Applications',
      cap1: "Full-Stack ",
      cap2: "SaaS ",
      cap3: "MVPs",
      text: 'Modern web platforms built with React 18, Next.js 15, Node.js, and PostgreSQL. Multi-tenant security, Stripe billing, role-based access, and automated team workspaces.',
      buttonLabel: 'Explore SaaS Solutions',
      imageSrc: '/images/b3.svg',
      altText: 'SaaS Platform and MVP Development',
    },
    {
      id: 4,
      caption: "Intelligent AI Automations",
      heading: 'Autonomous AI Workflows, Voice Agents & Custom RAG Chatbots',
      cap1: "Smart ",
      cap2: "AI ",
      cap3: "Superpowers",
      text: 'Accelerate your business with 24/7 AI conversational voice callers, multi-agent n8n/LangChain workflow pipelines, and private knowledge-base grounded assistants.',
      buttonLabel: 'Explore AI Automations',
      imageSrc: '/images/b4.svg',
      altText: 'AI Workflow Automation and Voice Agents',
    },
  ];

  const Thumbnails = [
    {
      id: 0,
      icon: <FaShoppingBag className="m-auto h-6 w-6" aria-hidden="true" />,
      label: 'Shopify Stores',
    },
    {
      id: 1,
      icon: <FaMobileAlt className="m-auto h-6 w-6" aria-hidden="true" />,
      label: 'Mobile Apps',
    },
    {
      id: 2,
      icon: <FaLaptopCode className="m-auto h-6 w-6" aria-hidden="true" />,
      label: 'SaaS & MVPs',
    },
    {
      id: 3,
      icon: <FaRobot className="m-auto h-6 w-6" aria-hidden="true" />,
      label: 'AI Automations',
    },
  ];

  return (
    <>
      <div className="bg-gradient-to-b from-white via-red-50/20 to-white py-6 sm:py-10">
        <Swiper
          style={{
            '--swiper-navigation-color': '#dc2626',
            '--swiper-pagination-color': '#dc2626',
          }}
          spaceBetween={10}
          navigation={true}
          modules={[Navigation, Thumbs]}
          className="mySwiper2"
          ref={mainSwiperRef}
          onSlideChange={(swiper) => setActiveThumb(swiper.activeIndex)}
        >
          {slides.map((slide) => (
            <SwiperSlide key={slide.id}>
              <div className="flex flex-col lg:flex-row w-[92%] max-w-7xl m-auto items-center py-4 min-h-[460px] lg:min-h-[500px]">
                <div className="lg:w-1/2 w-full p-4 sm:p-6 lg:p-8">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="h-[3px] bg-red-600 w-8 rounded-full"></span>
                    <span className="text-xs sm:text-sm font-semibold uppercase tracking-wider text-red-600">
                      {slide.caption}
                    </span>
                  </div>
                  {slide.id === 1 ? (
                    <h1 className="text-2xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900 mt-2 mb-3 leading-tight">
                      {slide.heading}
                    </h1>
                  ) : (
                    <h2 className="text-2xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900 mt-2 mb-3 leading-tight">
                      {slide.heading}
                    </h2>
                  )}
                  <div className="text-xl sm:text-2xl lg:text-3xl font-bold uppercase mb-4">
                    <span className="text-emerald-500">{slide.cap1}</span>
                    <span className="text-amber-500">{slide.cap2}</span>
                    <span className="text-red-600">{slide.cap3}</span>
                  </div>
                  <p className="text-gray-600 text-sm sm:text-base mb-6 leading-relaxed">
                    {slide.text}
                  </p>
                  
                  <div className="lg:hidden mb-6 flex justify-center min-h-[240px]">
                    <img
                      src={slide.imageSrc}
                      className="w-full max-h-[260px] object-contain drop-shadow"
                      alt={slide.altText}
                      width="520"
                      height="260"
                      style={{ aspectRatio: '520 / 260' }}
                      loading={slide.id === 1 ? 'eager' : 'lazy'}
                      fetchPriority={slide.id === 1 ? 'high' : 'auto'}
                      decoding="async"
                    />
                  </div>

                  <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                    <Link
                      to="/Services"
                      className="bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-8 rounded-xl text-center shadow-md transition flex items-center justify-center gap-2 text-sm sm:text-base"
                    >
                      {slide.buttonLabel} <FaArrowRight className="text-xs" aria-hidden="true" />
                    </Link>
                    <Link
                      to="/Form"
                      className="bg-gray-900 hover:bg-black text-white font-bold py-3 px-8 rounded-xl text-center shadow-md transition text-sm sm:text-base"
                    >
                      Get Project Quote
                    </Link>
                  </div>
                </div>

                <div className="lg:w-1/2 hidden lg:flex relative items-center justify-center p-6 min-h-[420px]">
                  <img
                    src={slide.imageSrc}
                    className="w-full max-h-[420px] object-contain drop-shadow-lg"
                    alt={slide.altText}
                    width="540"
                    height="420"
                    style={{ aspectRatio: '540 / 420' }}
                    loading={slide.id === 1 ? 'eager' : 'lazy'}
                    fetchPriority={slide.id === 1 ? 'high' : 'auto'}
                    decoding="async"
                  />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Desktop Thumbnails */}
        <div className="w-[92%] max-w-6xl hidden sm:block m-auto mt-6">
          <Swiper
            spaceBetween={14}
            slidesPerView={4}
            freeMode={true}
            watchSlidesProgress={true}
            className="mySwiper desktop"
          >
            {Thumbnails.map((thumb, index) => (
              <SwiperSlide key={thumb.id} onClick={() => handleThumbClick(thumb.id)}>
                <div
                  className={`cursor-pointer text-center p-4 rounded-xl transition duration-200 border ${
                    index === activeThumb
                      ? 'bg-white border-red-600 shadow-lg ring-2 ring-red-100'
                      : 'bg-white/80 border-gray-200 hover:bg-white hover:border-gray-300 shadow-sm'
                  }`}
                >
                  <span className={index === activeThumb ? 'text-red-600' : 'text-gray-500'}>
                    {thumb.icon}
                  </span>
                  <p className="text-sm font-bold text-gray-800 mt-2">
                    {thumb.label}
                  </p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Mobile Thumbnails */}
        <div className="block sm:hidden w-[92%] m-auto mt-4">
          <Swiper
            spaceBetween={10}
            slidesPerView={2.2}
            freeMode={true}
            watchSlidesProgress={true}
            className="mySwiper mobile"
          >
            {Thumbnails.map((thumb, index) => (
              <SwiperSlide key={thumb.id} onClick={() => handleThumbClick(thumb.id)}>
                <div
                  className={`cursor-pointer text-center p-3 rounded-xl border ${
                    index === activeThumb
                      ? 'bg-white border-red-600 shadow-md ring-2 ring-red-100'
                      : 'bg-white/90 border-gray-200'
                  }`}
                >
                  <span className={index === activeThumb ? 'text-red-600' : 'text-gray-500'}>
                    {thumb.icon}
                  </span>
                  <p className="text-xs font-bold text-gray-800 mt-1.5">
                    {thumb.label}
                  </p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </>
  );
};

export default Hero;